"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var InitialsWidget = function (props) {
    return react_1.default.createElement("div", null, "Initials widget goes here");
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(InitialsWidget, { componentName: "InitialsWidget" });
